<template>
  <v-container id="facturacion" tag="section">
    <base-v-component heading="Facturas de los negocios asociados" />
    <base-material-card
      color="indigo"
      icon="mdi-currency-eur"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer />
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="facturas"
        :loading="loading"
        :search="search"
        sort-by="generadaFecha"
        sort-desc
      >
        <template v-slot:item.estadoMostrar="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip
                small
                class="mr-2 pa-1"
                :class="item.transferido ? 'success' : 'red'"
                v-on="on"
                ><v-icon color="white">mdi-credit-card</v-icon></v-chip
              >
            </template>
            <span v-if="!item.transferido">No transferido el pago online</span>
            <span v-else
              >Transferido el pago online: {{ item.transferido }}</span
            >
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip
                small
                class="mr-2 pa-1"
                :class="item.cobrado ? 'success' : 'red'"
                v-on="on"
                ><v-icon color="white">mdi-currency-eur</v-icon></v-chip
              >
            </template>
            <span v-if="!item.cobrado">No cobrado</span>
            <span v-else>Cobrado: {{ item.cobrado }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip
                small
                class="mr-2 pa-1"
                :class="item.enviado ? 'success' : 'red'"
                v-on="on"
                ><v-icon color="white">mdi-email</v-icon></v-chip
              >
            </template>
            <span v-if="!item.enviado">No enviado por email</span>
            <span v-else>Enviado por email: {{ item.enviado }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-spacer></v-spacer>
          <v-tooltip
            left
            v-if="item.ficheros && !!item.ficheros.resumenComision"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="pink"
                min-width="0"
                v-on="on"
                small
                @click="goFile(item, 'resumenComision')"
              >
                <v-icon small>mdi-currency-eur</v-icon>
              </v-btn>
            </template>
            <span>Comisiones partner</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="info"
                min-width="0"
                v-on="on"
                small
                @click="goFile(item, 'pedidos')"
              >
                <v-icon small>mdi-format-list-bulleted</v-icon>
              </v-btn>
            </template>
            <span>Listado de pedidos</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="secondary"
                min-width="0"
                v-on="on"
                small
                @click="goFile(item, 'resumenFactura')"
              >
                <v-icon small>mdi-tooltip-text</v-icon>
              </v-btn>
            </template>
            <span>Resumen</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="success"
                min-width="0"
                v-on="on"
                small
                @click="goFile(item, 'factura')"
              >
                <v-icon small>mdi-file-pdf</v-icon>
              </v-btn>
            </template>
            <span>Factura</span>
          </v-tooltip>
        </template>
      </v-data-table></base-material-card
    ></v-container
  >
</template>


<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import { mostrarMoneda, idToTexto, mostrarIdioma } from "@/utils/utils.js";
export default {
  data() {
    return {
      loading: false,
      loadingEliminar: false,
      dialog: false,
      search: "",
      headers: [
        {
          sortable: false,
          text: "#",
          value: "id",
        },
        {
          sortable: false,
          text: "Cliente",
          value: "cliente",
        },
        {
          sortable: false,
          text: "Estado",
          value: "estadoMostrar",
        },
        {
          sortable: false,
          text: "Periodo",
          value: "periodo",
        },
        {
          sortable: false,
          text: "Total",
          value: "total",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
    };
  },
  computed: {
    facturas() {
      var facturas = this.$store.state.facturacion.facturasArray;
      var res = [];
      facturas.forEach((f) => {
        var foundTransferido, index;
        index = f.historial ? f.historial.length - 1 : -1;
        for (; index >= 0; index--) {
          if (f.historial[index].transferidoNegocio != undefined) {
            foundTransferido = f.historial[index];
            break;
          }
        }
        let transferido;
        if (foundTransferido) {
          transferido = moment(
            foundTransferido.transferidoNegocio.toDate()
          ).format("DD-MM-YYYY HH:mm");
        } else {
          transferido = false;
        }
        var foundCobrado, index;
        index = f.historial ? f.historial.length - 1 : -1;
        for (; index >= 0; index--) {
          if (f.historial[index].transferidoMewo != undefined) {
            foundCobrado = f.historial[index];
            break;
          }
        }
        let cobrado;
        if (foundCobrado) {
          cobrado = moment(foundCobrado.transferidoMewo.toDate()).format(
            "DD-MM-YYYY HH:mm"
          );
        } else {
          cobrado = false;
        }
        var foundEnviado, index;
        index = f.historial ? f.historial.length - 1 : -1;
        for (; index >= 0; index--) {
          if (f.historial[index].envioEmail != undefined) {
            foundEnviado = f.historial[index];
            break;
          }
        }
        let enviado;
        if (foundEnviado) {
          enviado = moment(foundEnviado.envioEmail.toDate()).format(
            "DD-MM-YYYY HH:mm"
          );
        } else {
          enviado = false;
        }
        res.push({
          ...f,
          id: f.id,
          modo: f.modo ? idToTexto(f.modo) : "-",
          cliente:
            f.modo == "negocio"
              ? idToTexto(f.negocio)
              : idToTexto(f.restaurante[0]),
          periodo: f.rango ? f.rango.join(" / ") : "-",
          total: f.resumen ? f.resumen.totalCantidadFacturar : "",
          estadoMostrar: idToTexto(f.estado),
          transferido: transferido,
          cobrado: cobrado,
          enviado: enviado,
        });
      });
      return res;
    },
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
    }),
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    subtitulo() {
      return "Listado de facturas de su negocio";
    },
  },
  watch: {},
  methods: {
    goFile(item, s) {
      window.open(item.ficheros[s], "_blank");
    },
    reload() {
      let _vm = this;
      _vm.loading = true;
      this.$store
        .dispatch("facturacion/getFacturasDirectorio")
        .then(() => {})
        .catch((e) => {
          console.log(e);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se han podido cargar las facturas " + e,
          });
        })
        .finally(() => (_vm.loading = false));
    },
  },
  mounted() {
    this.reload();
  },
};
</script>

<style>
</style>